/* Secondary photography for cards rendered after the initial Liquid response. */
(() => {
 const data = document.querySelector('[data-lr-card-catalog259]');
 if (!data) return;
 let products;
 try { products = JSON.parse(data.textContent); } catch { return; }
 const key = text => text.trim().toLowerCase().replace(/\s+/g, ' ');
 const titles = new Map(products.map(product => [key(product.title), product]));
 const handles = new Map(products.map(product => [product.handle, product]));
 const familyKey = text => key(text).replace(/(?:\(\d+[- ]pack\)|\b\d+[- ]pack\b)/g, '').replace(/\bdrinks?\b/g, '').replace(/[^a-z0-9ñ]/g, '');
 const families = new Map();
 for (const product of products) {
  const family = familyKey(product.title);
  families.set(family, families.has(family) ? null : product);
 }
 const handled = new WeakSet();
 let queued = false;
 function scan() {
  queued = false;
  document.querySelectorAll('.loop-bundle-product-card, .mega-product, .lr-recent-card105, .lr-quiz73-matches > article').forEach(card => {
   if (card.querySelector('.lr-card-second259')) return;
   const link = card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
   let handle = card.getAttribute('data-product-handle');
   try { handle ||= new URL(link?.getAttribute('href'), location.origin).pathname.match(/^\/products\/([^/]+)\/?$/)?.[1]; } catch {}
   const title = card.querySelector('.loop-bundle-product-card-title')?.textContent;
   const product = handles.get(handle) || (title && (titles.get(key(title)) || families.get(familyKey(title))));
   const primary = card.querySelector('img');
   if (!product?.image || !primary || handled.has(primary)) return;
   handled.add(primary);
   let frame = primary.parentElement;
   if (frame === card || frame === link) {
    frame = document.createElement('div');
    primary.before(frame);
    frame.append(primary);
   }
   if (!frame) return;
   frame.classList.add('lr-card-frame259');
   const second = document.createElement('img');
   second.className = 'lr-card-second259';
   second.alt = '';
   second.setAttribute('aria-hidden', 'true');
   second.loading = 'lazy';
   second.width = 900;
   second.height = 900;
   second.src = product.image;
   second.addEventListener('error', () => second.remove(), { once: true });
   frame.append(second);
  });
 }
 new MutationObserver(() => {
  if (!queued) { queued = true; requestAnimationFrame(scan); }
 }).observe(document.body, { childList: true, subtree: true });
 scan();
})();

/* Server-rendered catalogue savings for secondary cards; Loop keeps its own variant pricing. */
(()=>{const data=document.querySelector('[data-lr-card-catalog259]');if(!data)return;let products;try{products=JSON.parse(data.textContent);}catch{return;}const map=new Map(products.map(p=>[p.handle,p]));let queued=false;
 const scan=()=>{queued=false;document.querySelectorAll('.mega-product,.lr-recent-card105,.lr-quiz73-matches>article').forEach(card=>{if(card.querySelector('[data-lr-card-prices292]'))return;const link=card.matches('a')?card:card.querySelector('a[href*="/products/"]');let handle;try{handle=new URL(link?.getAttribute('href'),location.origin).pathname.match(/^\/products\/([^/]+)/)?.[1];}catch{}const product=map.get(handle);if(!product?.priceMarkup)return;const price=card.querySelector('.mega-price06')||card.querySelector('p');if(!price)return;const content=document.createElement('span');content.dataset.lrCardPrices292='';content.innerHTML=product.priceMarkup;price.replaceChildren(content);});};new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(scan);}}).observe(document.body,{childList:true,subtree:true});scan();})();
